import { render, staticRenderFns } from "./SMSTemplates.vue?vue&type=template&id=1e1fec78&scoped=true"
import script from "./SMSTemplates.vue?vue&type=script&lang=js"
export * from "./SMSTemplates.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplates.vue?vue&type=style&index=0&id=1e1fec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1fec78",
  null
  
)

export default component.exports